import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';

import FullPageLoader from '@/components/ui/FullPageLoader';

/**
 * Root page that redirects to /groups.
 * Route: /
 *
 * IMPORTANT: This page is in Pages Router (not App Router) because:
 * - The Login component depends on Redux state being initialized
 * - Redux initialization happens in Pages Router's AppProviders wrapper
 * - App Router and Pages Router have separate React trees, so Redux state isn't shared
 * - Having both public pages (/ and /login) in Pages Router ensures consistent state management
 *
 * Auth0 callbacks with code/state params will be handled by Auth0Provider before redirect.
 * Authentication checks happen at /groups via AuthenticatedPage wrapper.
 */
export default function HomePage(): ReactElement {
	const router = useRouter();

	useEffect(() => {
		// Simple redirect to groups - auth checks happen there
		router.replace('/groups').catch(() => {
			// Ignore navigation errors (e.g., navigation cancelled)
		});
	}, [router]);

	// Show loader while redirecting
	return <FullPageLoader />;
}
